import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ showFileName, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('attachment-preview')
    child.attrs = {
      ...child.attrs,
      showFileName
    }
    this.children = [child]
  }
}
